import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { PeopleService } from 'src/app/services/people/people.service';

type BackendError = { status?: number; error?: { message?: string } };

@Component({
    selector: 'app-invite-user-dialog',
    templateUrl: './invite-user-dialog.component.html',
    styleUrls: ['./invite-user-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InviteUserDialogComponent {
  /** Injected dependencies */
  private fb: FormBuilder = inject(FormBuilder);
  private dialogRef: MatDialogRef<InviteUserDialogComponent> = inject(MatDialogRef<InviteUserDialogComponent>);
  private peopleService: PeopleService = inject(PeopleService);
  private toastrService: ToastrService = inject(ToastrService);

  /** Status flags */
  public isSubmitting = false;
  public inviteExists = false;

  /** Available user groups for invitation */
  // NOTE: Currently not used, as group selection is removed from the form
  public groups = ['Admin'];

  /** Invite form definition */
  public inviteForm = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    //group:     ['', Validators.required],
  });

  /**
   * Closes the dialog
   */
  public close() {
    this.dialogRef.close();
  }

  /**
   * Send the invite using the form data and the invitation service
   */
  public sendInvite() {
    if (!this.inviteForm.valid) return;

    // Extract form values
    const formValue = this.inviteForm.value as {
      firstName: string;
      lastName: string;
      email: string;
    };

    this.isSubmitting = true;
    this.inviteExists = false;

    // Send the invitation
    this.peopleService.inviteMemberWithGroup(formValue).pipe(
      finalize(() => setTimeout(() => (this.isSubmitting = false), 500)),
    ).subscribe({
      next: signup => {
        this.toastrService.success('Invite sent successfully!', 'Success');
        this.dialogRef.close(signup);
      },
      error: (err: BackendError) => {
        // If the error indicates the user already exists, set the flag to render small text (product decision)
        const exists = err?.status === 400 && (err.error?.message ?? '').toLowerCase().includes('user already exists');
        if (exists) {
          this.inviteExists = true;
          return;
        }

        // Otherwise, log and show a generic error
        console.error('[INVITE-SERVICE] Error inviting member:', err);
        this.toastrService.error('Failed to send invite. Please try again.', 'Error');
      },
    });
  }

}
